<template>
  <div class="PostFormGroupPhotos">
    <h3>{{ title || $t("posts.components.picturesTitle") }}</h3>
    <p v-html="$t('posts.components.picturesText')"/>
    <p style="color: #d24554"><strong>Veuillez ne pas ajouter de filigrane sur vos photos. Un filigrane sera ajouté automatiquement avant la diffusion de ce bien vendu.</strong></p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PostFormGroupPhotos',
  props: {
    value: { type: Object, default: () => ({}) },
    title: String,
    description: String
  }
}
</script>
